import { createSlice } from '@reduxjs/toolkit';
import { UserProfile } from '../../data/types';
import { User } from '@supabase/supabase-js';

type AuthState = {
  userCurrent: UserProfile;
  userInfo: User | null;
}
const initialState: AuthState = {
  userCurrent: {
    coins: 0, id: "", created_at: "", sub_list: [],
    unlock_images: {}, subscription: [], phone_time: 0, unlock_theme: [],
    be_invited: null
  },
  userInfo: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUpdateUserProfily: (state, actions) => {
      state.userCurrent = actions.payload;
    },
    setUserInfo: (state, actions) => {
      state.userInfo = actions.payload; 
    }
  },
});

export const { setUpdateUserProfily, setUserInfo } = authSlice.actions;
export default authSlice.reducer;